import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/icons/metamask.svg';
import _imports_1 from '@/assets/images/icons/ledger.png';
import _imports_2 from '@/assets/images/icons/foxWallet.svg';
import _imports_3 from '@/assets/images/icons/walletconnect.svg';
import _imports_4 from '@/assets/images/icons/metamaskflask.png';
import _imports_5 from '@/assets/images/icons/eth.svg';
import _imports_6 from '@/assets/images/icons/fil.svg';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "row mt-4"
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "col-7 referrals-col-spacing"
};
const _hoisted_6 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-10 dashboard-card",
  style: {
    "height": "100%"
  }
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-row mb-3 mt-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "fw-extra-bold fsi-20"
}, "我的信息"), /*#__PURE__*/_createElementVNode("div")], -1);
const _hoisted_8 = {
  class: "d-flex align-items-center",
  style: {
    "gap": "20px"
  }
};
const _hoisted_9 = {
  style: {
    "width": "56px",
    "height": "56px"
  },
  class: "position-relative"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "avatar",
  style: {
    "width": "56px",
    "height": "56px",
    "border-radius": "56px",
    "overflow": "hidden"
  }
}, null, -1);
const _hoisted_11 = {
  class: "flex-center",
  style: {
    "position": "absolute",
    "right": "-3px",
    "bottom": "-3px",
    "z-index": "2",
    "width": "20px",
    "height": "20px",
    "border-radius": "20px",
    "background-color": "white"
  }
};
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_14 = {
  key: 2,
  src: _imports_1,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_15 = {
  key: 3,
  src: _imports_2,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_16 = {
  key: 4,
  src: _imports_3,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_17 = {
  key: 5,
  src: _imports_4,
  style: {
    "width": "20px"
  },
  alt: ""
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {
    "width": "20px"
  }
}), /*#__PURE__*/_createElementVNode("span", {
  class: "fs-12 ml-1"
}, "0x9afa3feBDc382a94493a85103d763d09B5112aBC")]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  style: {
    "width": "18px"
  }
}), /*#__PURE__*/_createElementVNode("span", {
  class: "fs-12 ml-1"
}, "t410ftl5d7264havjisj2quid25r5bg2rckv4f2gc7sy")])], -1);
const _hoisted_19 = {
  class: "row",
  style: {
    "margin-top": "2rem"
  }
};
const _hoisted_20 = {
  class: "col-4"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "subheading-text fw-medium fsi-14"
}, " FIL余额 ", -1);
const _hoisted_22 = {
  class: "fw-bold fsi-18"
};
const _hoisted_23 = {
  class: "col-4"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "subheading-text fw-medium fsi-14"
}, " stFIL余额 ", -1);
const _hoisted_25 = {
  class: "fw-bold fsi-18"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-4"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "subheading-text fw-medium fsi-14"
}, " 质押总利息 "), /*#__PURE__*/_createElementVNode("div", {
  class: "fw-bold fsi-18"
}, " 0 stFIL ")], -1);
const _hoisted_27 = {
  class: "col-5 referrals-col-spacing"
};
const _hoisted_28 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-10 dashboard-card"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-row mb-3 mt-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "fw-extra-bold fsi-20"
}, "转账"), /*#__PURE__*/_createElementVNode("div")], -1);
const _hoisted_30 = {
  class: "d-flex align-items-center"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "17%"
  },
  class: "fsi-14"
}, "Token", -1);
const _hoisted_32 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_33 = {
  class: "d-flex align-items-center",
  style: {
    "margin-top": "1.8rem"
  }
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "17%"
  },
  class: "fsi-14"
}, "From", -1);
const _hoisted_35 = {
  class: "transfer-input",
  style: {
    "flex": "1"
  }
};
const _hoisted_36 = {
  class: "d-flex align-items-center",
  style: {
    "margin-top": "1.8rem"
  }
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "17%"
  },
  class: "fsi-14"
}, "To", -1);
const _hoisted_38 = {
  class: "transfer-input",
  style: {
    "flex": "1"
  }
};
const _hoisted_39 = {
  class: "d-flex align-items-center",
  style: {
    "margin-top": "1.8rem"
  }
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "17%"
  },
  class: "fsi-14"
}, "Amount", -1);
const _hoisted_41 = {
  class: "transfer-input",
  style: {
    "flex": "1"
  }
};
const _hoisted_42 = {
  class: "d-flex align-items-center",
  style: {
    "margin-top": "1.8rem"
  }
};
const _hoisted_43 = {
  style: {
    "width": "16%"
  },
  class: "mr-2"
};
const _hoisted_44 = {
  style: {
    "width": "83%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [$data.connectType === 'MetaMask' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _createCommentVNode("", true), $data.connectType === 'Ledger' ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true), $data.connectType === 'LedgerEth' ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true), $data.connectType === 'foxWallet' ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true), $data.connectType === 'WalletConnect' ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : _createCommentVNode("", true), $data.connectType === 'MetaMaskFlask' ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : _createCommentVNode("", true)])]), _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString($options.formatWalletFilPrice(_ctx.filBalance, 4, false)), 1)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString($options.formatWalletFilPrice(_ctx.stFilBalance, 4, true)), 1)]), _hoisted_26])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createVNode(_component_RadioBtn, {
    "tab-arr": $data.radioOptions,
    modelValue: $data.form.token,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.token = $event)
  }, null, 8, ["tab-arr", "modelValue"])])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_input, {
    disabled: "",
    style: {
      "height": "45px",
      "font-size": "13px"
    },
    modelValue: $data.form.from,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.from = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_input, {
    style: {
      "height": "45px",
      "font-size": "13px"
    },
    modelValue: $data.form.to,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.to = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_input, {
    style: {
      "height": "45px"
    },
    modelValue: $data.form.amount,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.amount = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    style: {
      "border-radius": "8px!important"
    }
  }, {
    default: _withCtx(() => [_createTextVNode("Clear")]),
    _: 1
  })]), _createElementVNode("div", _hoisted_44, [_createVNode(_component_el_button, {
    class: "btn btn-success w-100 i-button",
    style: {
      "border-radius": "8px!important"
    }
  }, {
    default: _withCtx(() => [_createTextVNode("Send")]),
    _: 1
  })])])])])])])])]);
}